import React, { Fragment } from 'react';
import { PageTitle } from '@components/PageTitle';
import { IPortalPageLayout } from './interface';
import { ContentWithSidebar } from '@components/ContentWithSidebar';
import { WindowPageTitle } from '@components/WindowPageTitle';

export const PortalPageLayout: React.FC<IPortalPageLayout> = ({
  title,
  subTitle,
  backLink,
  sidebarContent,
  wrapContentInPanel,
  afterContent,
  children,
  hidePageTitle = false,
}): JSX.Element => {
  return (
    <Fragment>
      <WindowPageTitle title={title} />

      <ContentWithSidebar
        sidebarContent={sidebarContent}
        wrapContentInPanel={wrapContentInPanel}
        afterContent={afterContent}
      >
        {!hidePageTitle && title && (
          <PageTitle title={title} subTitle={subTitle} backLink={backLink} />
        )}
        {children}
      </ContentWithSidebar>
    </Fragment>
  );
};
